var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconBookStore = function SvgIconBookStore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.956,
    height: 37.312,
    viewBox: "0 0 25.956 37.312",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_map-book-store",
    "data-name": "Icon map-book-store",
    d: "M32.436,32.263V4.684A3.254,3.254,0,0,0,29.191,1.44H9.724A3.254,3.254,0,0,0,6.48,4.684V35.507a3.254,3.254,0,0,0,3.244,3.244H29.191c1.507,0,3.244,0,3.244-1.622v-.811h-21.9A1.627,1.627,0,0,1,8.913,34.7V32.263ZM10.536,7.929a.814.814,0,0,1,.811-.811H27.569a.814.814,0,0,1,.811.811V9.551a.814.814,0,0,1-.811.811H11.347a.814.814,0,0,1-.811-.811V7.929Zm0,6.489a.814.814,0,0,1,.811-.811H27.569a.814.814,0,0,1,.811.811V16.04a.814.814,0,0,1-.811.811H11.347a.814.814,0,0,1-.811-.811V14.418Z",
    transform: "translate(-6.48 -1.44)",
    fill: "#f6c866"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconBookStore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-book-store.8e811918.svg";
export { ForwardRef as ReactComponent };